import * as React from "react";
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import {EditProduct, Product, Result, Salepoint, StockPrice} from "./uc/domain.ts"
import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Alert, Button,
    Dialog,
    Grid,
    Input,
    Paper,
    Slider,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {useNotifications} from "@toolpad/core/useNotifications";
// import {useAppContext} from "./Context.tsx";
import useSalepoints from "./useSalepoints.ts";


interface ProductEditProps {
    editableProduct: EditProduct | null
    setCurrentEditProduct: (productRef: string|null, qty?:number) => Promise<void>
}

const style = {
    bgcolor: 'background.paper',
    border: '2px solid #666',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
}

const ProductEdit: React.FC<ProductEditProps> = (props) => {
    const notify = useNotifications()
    const [maximumCount, setMaximumCount] = useState(1)
    const [currentCount, setCurrentCount] = useState(props.editableProduct?.product.quantity || 1)
    // остатки товара по городу
    const [stockPriceInCurrentCity, setStockPriceInCurrentCity] = useState(props.editableProduct?.stockPrice||[])
    const {allShops,shopsByCity, favoriteShop} = useSalepoints()
    const getSalepointByRef = (s: string): Salepoint | undefined => {
       const shops = allShops.filter(el =>  el.sanremoRef == s)
       if (shops.length == 1)  {
           return shops[0]
       }
       return undefined
    }
    useEffect(() => {
        setCurrentCount(props.editableProduct?.product.quantity || 1)
        const setOfShopsRef = new Set();
        shopsByCity.forEach(el => setOfShopsRef.add(el.sanremoRef))
        const stockPrice = props.editableProduct?.stockPrice || []
        const stockPriceInCity:StockPrice[] = stockPrice.filter(el => setOfShopsRef.has(el.salePointUid) && el.count > 0)
        const current = stockPriceInCity.find(el => el.salePointUid === favoriteShop?.sanremoRef)
        if (current !== undefined) {
            setMaximumCount(current.count || 0)
        } else {
            setMaximumCount(0)
        }
        setStockPriceInCurrentCity(stockPriceInCity)
    }, [props.editableProduct]);
    const handleSliderChange = (event: Event, newValue: number | number[], activeThumb: number) => {
        if (typeof newValue === 'number') {
            setCurrentCount(newValue)
        }
    }
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value === '' ? 0 : Number(event.target.value)
        setCurrentCount(Math.min(maximumCount, newValue))
    }
    const handleBlur = () => {
        console.log('handle blur')
    }
    return <>
        <Dialog open={props.editableProduct !== null} scroll="body" onClose={() => {
            props.setCurrentEditProduct(null,0)
        }}>
            <Box sx={style}>
                <Accordion style={{marginBottom: '20px'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography component="span">
                            [{props.editableProduct?.product?.code}] {props.editableProduct?.product?.article} {props.editableProduct?.product.name}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack spacing={2}>
                            <img src={props.editableProduct?.product?.image_url} alt={props.editableProduct?.product?.name} style={{maxWidth: "275px"}}/>
                            <Typography dangerouslySetInnerHTML={{__html: props.editableProduct?.product?.description || ""}}/>
                        </Stack>
                    </AccordionDetails>
                </Accordion>
                {maximumCount > 0  && <Grid container={true} spacing={2} sx={{alignItems: 'center', marginBottom: '20px'}}>
                    <Grid>
                        Количество
                    </Grid>
                    <Grid size="grow">
                        <Slider
                            value={currentCount}
                            max={maximumCount}
                            onChange={handleSliderChange}
                            aria-labelledby="input-slider"
                        />
                    </Grid>
                    <Grid>
                        <Input
                            value={currentCount}
                            size="small"
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            inputProps={{
                                step: 10,
                                min: 0,
                                max: 100,
                                type: 'number',
                                'aria-labelledby': 'input-slider',
                            }}
                        />
                    </Grid>
                </Grid>}
                {maximumCount === 0 && <span style={{
                    padding: "10px", marginBottom: "10px", display:"block",
                    background: "#ff9548", borderRadius: "5px", color:"#fff"}}>
                    товара нет в наличии в выбранном магазине </span>}
                <Alert icon={<CurrencyRubleIcon fontSize="inherit" />} severity="success" sx={{
                    '& .MuiAlert-message': {
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'space-between'
                    },
                    marginBottom: '20px'
                }}>
                    <span>
                    <strong>Цена:</strong> {props.editableProduct?.product?.price} руб </span>
                    <span>
                    <strong>Сумма:</strong> {props.editableProduct?.product?.price * (currentCount|| 1)} руб.
                    </span>
                </Alert>
                <Accordion style={{marginBottom: '20px'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography component="span">
                            <span>Остатки этого товара в вашем городе</span>
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer component={Paper} style={{marginBottom:"20px"}}>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Магазин</TableCell>
                                        <TableCell>Остаток</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {stockPriceInCurrentCity.map((row) => (
                                        <TableRow
                                            key={row.salePointUid}
                                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                        >
                                            <TableCell component="th" scope="row">
                                                {getSalepointByRef(row.salePointUid)?.name}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.count}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
                <Box display="flex"
                     justifyContent="space-between"
                     alignItems="center"
                     width="100%"
                     gap={2}>
                    <Button variant="contained" color="white" onClick={() => {props.setCurrentEditProduct(null)}}>Отмена</Button>
                    <Button variant="contained" color="primary" onClick={() => {
                        props.setCurrentEditProduct(props.editableProduct!.product.id, currentCount).then(() => {
                            props.setCurrentEditProduct(null).then()
                        })
                    }}>Подтвердить</Button>
                </Box>
            </Box>
        </Dialog>
    </>
}
export default ProductEdit;